module.exports = [{"type":"title","text":"2024-08-22"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"永續websocket：倉位新增已實現盈虧cr字段"},{"type":"html","text":"現貨行情接口：/openApi/spot/v1/common/symbols新增：offTime、maintainTime字段。"},{"type":"html","text":"永續行情接口：/openApi/swap/v2/quote/contracts新增：brokerState字段"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2024-08-22.json
// module id = L5DY
// module chunks = 3